<div class="apa-card">
  <div class="apa-header">
    <div class="apa-title">{{ data?.title || 'APA RANGES' }}</div>
    <button
      *ngIf="showSubmitButton"
      class="apa-submit"
      type="button"
      [disabled]="isSubmitting"
      (click)="submitRanges()">
      {{ isSubmitting ? 'Submitting' : submitButtonLabel }}
    </button>
  </div>

  <div class="apa-grid" *ngIf="rows.length; else emptyState">
    <div class="apa-row" [class.readonly]="!isRangeEditable" *ngFor="let row of rows">
      <div class="label">{{ row.label }}</div>
      <label class="boundary min" aria-label="Minimum percentage">
        <input
          class="boundary-input"
          type="number"
          [disabled]="!isRangeEditable"
          [(ngModel)]="row.min"
          [ngModelOptions]="{ updateOn: 'blur' }"
          [min]="getMinBoundaryInputMin()"
          [max]="getMinBoundaryInputMax(row)"
          [step]="getStep(row)"
          (input)="onBoundaryInput(row, 'min', $event)"
          (ngModelChange)="onBoundaryChange(row, 'min')"
        />
        <span>%</span>
      </label>
      <div class="track">
        <div class="fill" [style.width.%]="getPositionPercent(row)"></div>
        <div class="marker" [style.left.%]="getPositionPercent(row)"></div>
        <input
          class="slider-hit"
          type="range"
          [disabled]="!isRangeEditable"
          [min]="row.min"
          [max]="row.max"
          [step]="getStep(row)"
          [value]="row.currentValue"
          (input)="onSlide(row, $event)"
        />
        <div class="value" [style.--apa-value-position]="getPositionPercent(row)">
          {{ formatDisplayValue(row.currentValue) }}%
        </div>
      </div>
      <label class="boundary max" aria-label="Maximum percentage">
        <input
          class="boundary-input"
          type="number"
          [disabled]="!isRangeEditable"
          [(ngModel)]="row.max"
          [ngModelOptions]="{ updateOn: 'blur' }"
          [min]="getMaxBoundaryInputMin(row)"
          [max]="getMaxBoundaryInputMax()"
          [step]="getStep(row)"
          (input)="onBoundaryInput(row, 'max', $event)"
          (ngModelChange)="onBoundaryChange(row, 'max')"
        />
        <span>%</span>
      </label>
    </div>
  </div>

  <div class="apa-submit-message" [class.error]="submitState === 'error'" *ngIf="submitMessage">
    {{ submitMessage }}
  </div>

  <ng-template #emptyState>
    <div class="empty">No APA ranges available.</div>
  </ng-template>
</div>
